<template>
  <page :load="doInit">
    <v-card>
      <v-card-title>
        <span class="headline">Clear Caches</span>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-flex xs6>
            <v-layout row>
              <v-flex d-flex align-center justify-start xs8>
                Clear Privileges Cache
              </v-flex>
              <v-flex>
                <v-btn :loading="submitting" @click="doClearPrivilege">Clear</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      menu: {},
      submitting: false
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.$store.state.app.menu.cacheControl
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.menu = extractMenu(data._links)
          }
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doClearPrivilege() {
      const apiURI = this.menu.clearPrivileges
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
